import { defaultWidgets } from '../../widgets/widgets';
import { withCustomPage } from './with-custom-page';
import { CustomPageDefault } from './component';

export const CustomPage = withCustomPage(defaultWidgets)(CustomPageDefault);
